<template>

  <div class="form-group">
    <label class="form-label">Событие*</label>

    <div class="checkbox-group">
      <div class="label-checkbox-pair">
        <input id="money-loss" type="checkbox" v-model="moneyLossIsChecked">
        <label for="money-loss">Утрата денежных средств</label>
      </div>
      <div class="sub-input-container" v-if="moneyLossIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[moneyLoss]" v-model="moneyLossValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="card-reissue" type="checkbox" v-model="cardReissueIsChecked">
        <label for="card-reissue">Перевыпуск карты</label>
      </div>
      <div class="sub-input-container" v-if="cardReissueIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[cardReissue]" v-model="cardReissueValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="documents-restoration" type="checkbox" v-model="documentsRestorationIsChecked">
        <label for="documents-restoration">Восстановление документов</label>
      </div>
      <div class="sub-input-container" v-if="documentsRestorationIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[documentsRestoration]" v-model="documentsRestorationValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="keys-replacement" type="checkbox" v-model="keysReplacementIsChecked">
        <label for="keys-replacement">Замена ключей и запирающих устройств</label>
      </div>
      <div class="sub-input-container" v-if="keysReplacementIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[keysReplacement]" v-model="keysReplacementValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="phone-purchase" type="checkbox" v-model="phonePurchaseIsChecked">
        <label for="phone-purchase">Приобретение мобильного телефона</label>
      </div>
      <div class="sub-input-container" v-if="phonePurchaseIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[phonePurchase]" v-model="phonePurchaseValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="acquisition-equipment" type="checkbox" v-model="acquisitionEquipmentIsChecked">
        <label for="acquisition-equipment">Приобретение техники</label>
      </div>
      <div class="sub-input-container" v-if="acquisitionEquipmentIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[acquisitionEquipment]" v-model="acquisitionEquipmentValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="involuntary-loan-processing" type="checkbox" v-model="involuntaryLoanProcessingIsChecked">
        <label for="involuntary-loan-processing">Недобровольное оформление кредита</label>
      </div>
      <div class="sub-input-container" v-if="involuntaryLoanProcessingIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[involuntaryLoanProcessing]" v-model="involuntaryLoanProcessingValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="leaving-life" type="checkbox" v-model="leavingLifeIsChecked">
        <label for="leaving-life">Уход из жизни</label>
      </div>
      <div class="sub-input-container" v-if="leavingLifeIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[leavingLife]" v-model="leavingLifeValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="first-disability-group" type="checkbox" v-model="firstDisabilityGroupIsChecked">
        <label for="first-disability-group"> Инвалидность I группы</label>
      </div>
      <div class="sub-input-container" v-if="firstDisabilityGroupIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[firstDisabilityGroup]" v-model="firstDisabilityGroupValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="second-disability-group" type="checkbox" v-model="secondDisabilityGroupIsChecked">
        <label for="second-disability-group"> Инвалидность II группы</label>
      </div>
      <div class="sub-input-container" v-if="secondDisabilityGroupIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[secondDisabilityGroup]" v-model="secondDisabilityGroupValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="temporary-disability" type="checkbox" v-model="temporaryDisabilityIsChecked">
        <label for="temporary-disability">Временная нетрудоспособность</label>
      </div>
      <div class="sub-input-container" v-if="temporaryDisabilityIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[temporaryDisability]" v-model="temporaryDisabilityValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="injury" type="checkbox" v-model="injuryIsChecked">
        <label for="injury">Травма</label>
      </div>
      <div class="sub-input-container" v-if="injuryIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[injury]" v-model="injuryValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>
      <div class="label-checkbox-pair">
        <input id="hospitalization" type="checkbox" v-model="hospitalizationIsChecked">
        <label for="hospitalization">Госпитализация</label>
      </div>
      <div class="sub-input-container" v-if="hospitalizationIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[hospitalization]" v-model="hospitalizationValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>

      <div class="label-checkbox-pair">
        <input id="other" type="checkbox" v-model="otherIsChecked">
        <label for="other">Другое</label>
      </div>
      <div class="sub-input-container" v-if="otherIsChecked">
        <span class="sub-input-container__subtitle">Заявляемая сумма ущерба</span>
        <input type="number" class="sub-input-container__input" name="bankCardEvents[other]" v-model="otherValue">
        <span class="sub-input-container__postfix"> руб.</span>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
  import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
  import * as mns from '@/store/mutation-types';

  // TODO: Разделить компонент на несколько файлов: html, js, css.
  export default {
    anotherNameLife: "BankCardProtection",
    components: {ContractInfoApplicant},
    computed: {
      moneyLossIsChecked: {
        get(){
          return this.$store.getters.moneyLoss.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_MONEY_LOSS_IS_CHECKED, value);
        }
      },
      moneyLossValue: {
        get(){
          return this.$store.getters.moneyLoss.value;
        },
        set(value){
          this.$store.commit(mns.SET_MONEY_LOSS_VALUE, value)
        }
      },
      cardReissueIsChecked: {
        get(){
          return this.$store.getters.cardReissue.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_CARD_REISSUE_IS_CHECKED, value);
        }
      },
      cardReissueValue: {
        get(){
          return this.$store.getters.cardReissue.value;
        },
        set(value){
          this.$store.commit(mns.SET_CARD_REISSUE_VALUE, value)
        }
      },
      documentsRestorationIsChecked: {
        get(){
          return this.$store.getters.documentsRestoration.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_DOCUMENTS_RESTORATION_IS_CHECKED, value);
        }
      },
      documentsRestorationValue: {
        get(){
          return this.$store.getters.documentsRestoration.value;
        },
        set(value){
          this.$store.commit(mns.SET_DOCUMENTS_RESTORATION_VALUE, value)
        }
      },
      keysReplacementIsChecked: {
        get(){
          return this.$store.getters.keysReplacement.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_KEYS_REPLACEMENT_IS_CHECKED, value);
        }
      },
      keysReplacementValue: {
        get(){
          return this.$store.getters.keysReplacement.value;
        },
        set(value){
          this.$store.commit(mns.SET_KEYS_REPLACEMENT_VALUE, value)
        }
      },
      phonePurchaseIsChecked: {
        get(){
          return this.$store.getters.phonePurchase.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_PHONE_PURCHASE_IS_CHECKED, value);
        }
      },
      phonePurchaseValue: {
        get(){
          return this.$store.getters.phonePurchase.value;
        },
        set(value){
          this.$store.commit(mns.SET_PHONE_PURCHASE_VALUE, value)
        }
      },
      acquisitionEquipmentIsChecked: {
        get(){
          return this.$store.getters.acquisitionEquipment.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_ACQUISITION_EQUIPMENT_IS_CHECKED, value);
        }
      },
      acquisitionEquipmentValue: {
        get(){
          return this.$store.getters.acquisitionEquipment.value;
        },
        set(value){
          this.$store.commit(mns.SET_ACQUISITION_EQUIPMENT_VALUE, value)
        }
      },
      involuntaryLoanProcessingIsChecked: {
        get(){
          return this.$store.getters.involuntaryLoanProcessing.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED, value);
        }
      },
      involuntaryLoanProcessingValue: {
        get(){
          return this.$store.getters.involuntaryLoanProcessing.value;
        },
        set(value){
          this.$store.commit(mns.SET_INVOLUNTARY_LOAN_PROCESSING_VALUE, value)
        }
      },
      leavingLifeIsChecked: {
        get(){
          return this.$store.getters.leavingLife.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_LEAVING_LIFE_IS_CHECKED, value);
        }
      },
      leavingLifeValue: {
        get(){
          return this.$store.getters.leavingLife.value;
        },
        set(value){
          this.$store.commit(mns.SET_LEAVING_LIFE_VALUE, value)
        }
      },
      firstDisabilityGroupIsChecked: {
        get(){
          return this.$store.getters.firstDisabilityGroup.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_FIRST_DISABILITY_GROUP_IS_CHECKED, value);
        }
      },
      firstDisabilityGroupValue: {
        get(){
          return this.$store.getters.firstDisabilityGroup.value;
        },
        set(value){
          this.$store.commit(mns.SET_FIRST_DISABILITY_GROUP_VALUE, value)
        }
      },
      secondDisabilityGroupIsChecked: {
        get(){
          return this.$store.getters.secondDisabilityGroup.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_SECOND_DISABILITY_GROUP_IS_CHECKED, value);
        }
      },
      secondDisabilityGroupValue: {
        get(){
          return this.$store.getters.secondDisabilityGroup.value;
        },
        set(value){
          this.$store.commit(mns.SET_SECOND_DISABILITY_GROUP_VALUE, value)
        }
      },
      temporaryDisabilityIsChecked: {
        get(){
          return this.$store.getters.temporaryDisability.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_TEMPORARY_DISABILITY_IS_CHECKED, value);
        }
      },
      temporaryDisabilityValue: {
        get(){
          return this.$store.getters.temporaryDisability.value;
        },
        set(value){
          this.$store.commit(mns.SET_TEMPORARY_DISABILITY_VALUE, value)
        }
      },
      injuryIsChecked: {
        get(){
          return this.$store.getters.injury.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_INJURY_IS_CHECKED, value);
        }
      },
      injuryValue: {
        get(){
          return this.$store.getters.injury.value;
        },
        set(value){
          this.$store.commit(mns.SET_INJURY_VALUE, value)
        }
      },
      hospitalizationIsChecked: {
        get(){
          return this.$store.getters.hospitalization.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_HOSPITALIZATION_IS_CHECKED, value);
        }
      },
      hospitalizationValue: {
        get(){
          return this.$store.getters.hospitalization.value;
        },
        set(value){
          this.$store.commit(mns.SET_HOSPITALIZATION_VALUE, value)
        }
      },
      otherIsChecked: {
        get(){
          return this.$store.getters.other.isChecked;
        },
        set(value){
          this.$store.commit(mns.SET_OTHER_IS_CHECKED, value);
        }
      },
      otherValue: {
        get(){
          return this.$store.getters.other.value;
        },
        set(value){
          this.$store.commit(mns.SET_OTHER_VALUE, value)
        }
      },
      comments: {
        get(){
          return this.$store.getters.comments;
        },
        set(value){
          this.$store.commit(mns.SET_COMMENTS, value);
        }
      }
    }
  }
</script>

<style scoped>
  .sub-input-container{
    margin-bottom: 10px;
  }
  .sub-input-container__subtitle{
    display: block;
    font-size: .8rem;
    color: #9e9e9e;
  }
  .sub-input-container__input{
    border: 1px solid #666;
    outline: none;
    font-size: 100%;
    line-height: 1.15;
  }
  .sub-input-container__postfix{
    color: #9e9e9e;
    font-size: .8rem;
  }
</style>